export default __webpack_public_path__ + "static/media/logo.394a6ee5.png";